<template>
    <b-container>

        <h1>Ваш список сайтов </h1>


        <div v-if="status!=='success'">
            <font-awesome-icon icon="spinner" spin></font-awesome-icon>
        </div>

        <div v-if="status==='success'">
            <div class="row">
                <div v-bind:class="{'col-md-4 col-12':selectedDomain, 'col-12':!selectedDomain}">
                    <div class="form-group">
                        <router-link :to="{name: 'domainCreate'}" class="btn btn-success">Добавить новый сайт
                        </router-link>
                    </div>
                    <b-list-group>
                        <b-list-group-item v-for="domain in domains" v-bind:key="domain.id" action
                                           :active="domain === selectedDomain"
                                           @click="select(domain)">
                            <strong>
                                {{domain.domain_name}}
                            </strong>
                            <div>
                                <span v-if="domain.description"> Описание: {{domain.description}} <br></span>
                                Hash: {{domain.domain_hash}}
                            </div>

                        </b-list-group-item>
                    </b-list-group>
                </div>
                <div v-if="selectedDomain" class="col-md-8 col-12">
                    <b-card no-body>
                        <b-tabs card v-model="activeTab">
                            <b-tab title="Общая информация">
                                <domain-info class="mt-3" v-bind:domain="selectedDomain"></domain-info>
                            </b-tab>
                            <b-tab title="Интеграция с Вконтакте">
                                <domain-vk-integration class="mt-3"
                                                       v-bind:domain="selectedDomain"></domain-vk-integration>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </div>
            </div>
        </div>
    </b-container>
</template>

<script>
    import {mapState} from 'vuex'
    import DomainInfo from "./DomainInfo";
    import {DOMAINS_SELECT} from "../../store/actions/domains";
    import DomainVkIntegration from "./DomainVkIntegration";

    export default {
        components: {DomainInfo, DomainVkIntegration},
        computed: mapState({
            profile: state => state.user.profile,
            domains: state => state.domains.domains,
            status: state => state.domains.status,
            selectedDomain: state => state.domains.selectedDomain
        }),

        data: function () {
            return {
                activeTab: 0
            };
        },
        mounted() {
        },
        methods: {
            select(domain) {
                this.$store.commit(DOMAINS_SELECT, domain);
            }
        }
    }
</script>